export const PublishBitrates = {
	screenShare: 2048000,
	screenShareUltra: 2048000,
	low: 256000,
	medium: 512000,
	high: 768000,
	ultra: 3072000,
	ultra4k: 4096000,
}
